import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Plug, Battery, Banknote } from 'lucide-react';
import { fadeInUp } from '../../lib/animations';
import DecimalInput from '../ui/DecimalInput';


const CARROS = [
  { id: 'dolphin', nome: 'BYD Dolphin (44.9 kWh)', bateria: 44.9 },
  { id: 'haval', nome: 'GWM Haval H6 PHEV (34 kWh)', bateria: 34 },
  { id: 'xc40', nome: 'Volvo XC40 (69 kWh)', bateria: 69 },
  { id: 'kwid', nome: 'Renault Kwid E-Tech (26.8 kWh)', bateria: 26.8 }
];

const CARREGADORES = [
  { id: 'tomada', nome: 'Tomada Comum (1.8 kW)', potencia: 1.8 },
  { id: 'wallbox7', nome: 'Wallbox Residencial (7.4 kW)', potencia: 7.4 },
  { id: 'wallbox22', nome: 'Wallbox Residencial (22 kW)', potencia: 22 },
  { id: 'dc50', nome: 'Rápido DC (50 kW)', potencia: 50 }
];

const SimuladorRecarga: React.FC = () => {
  const [carroId, setCarroId] = useState(CARROS[0].id);
  const [carregadorId, setCarregadorId] = useState(CARREGADORES[1].id);
  const [percentualAtual, setPercentualAtual] = useState(20);
  const [tarifaKwh, setTarifaKwh] = useState(0.95);

  const carro = CARROS.find(c => c.id === carroId)!;
  const carregador = CARREGADORES.find(c => c.id === carregadorId)!;

  const kwhFaltante = carro.bateria * ((100 - percentualAtual) / 100);
  // Adicionando 10% de perda linear na recarga
  const tempoHoras = (kwhFaltante / carregador.potencia) * 1.1;
  const horasInteiras = Math.floor(tempoHoras);
  const minutos = Math.round((tempoHoras - horasInteiras) * 60);

  const custoTotal = kwhFaltante * tarifaKwh;

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <motion.div variants={fadeInUp} className="overflow-hidden rounded-2xl bg-slate-900 shadow-xl shadow-slate-900/40 border border-slate-800">
        <div className="bg-amber-400 p-6 sm:p-8 text-center">
           <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-950/30">
            <Zap className="h-7 w-7 text-white" strokeWidth={1.8} />
          </div>
          <h2 className="font-display text-2xl font-bold text-white mb-2">Calculadora de Recarga EV</h2>
        </div>

        <div className="p-6 sm:p-8 grid gap-8 md:grid-cols-2">
           <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-400 mb-1">Qual é o seu carro?</label>
                <select value={carroId} onChange={e => setCarroId(e.target.value)} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none">
                  {CARROS.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-400 mb-1">Tipo de Carregador</label>
                <select value={carregadorId} onChange={e => setCarregadorId(e.target.value)} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm focus:border-amber-400 focus:outline-none">
                  {CARREGADORES.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-400 mb-1">% Atual da Bateria</label>
                  <input type="number" min="0" max="99" value={percentualAtual} onChange={e => setPercentualAtual(Number(e.target.value))} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm text-white focus:border-amber-400 focus:outline-none" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-400 mb-1">Custo kWh (R$)</label>
                  <DecimalInput value={tarifaKwh} onChange={setTarifaKwh} className="w-full rounded-xl border border-slate-700 bg-slate-800 px-4 py-2.5 text-sm text-white focus:border-amber-400 focus:outline-none" />
                </div>
              </div>
           </div>

           <div className="flex flex-col gap-4 justify-center">
              <div className="bg-emerald-400/10 text-emerald-400 border border-emerald-400/30 p-5 rounded-xl text-center shadow-sm">
                 <p className="text-xs text-emerald-400 font-bold uppercase tracking-wider mb-1 flex justify-center items-center gap-1"><Battery className="h-4 w-4"/> Tempo Estimado de Recarga</p>
                 <div className="font-display text-3xl font-black text-emerald-400">
                   {horasInteiras}h {minutos}m
                 </div>
                 <p className="text-xs mt-1 text-emerald-400">Até atingir 100%</p>
              </div>

              <div className="bg-blue-400/10 text-blue-400 border border-blue-400/30 p-5 rounded-xl text-center shadow-sm">
                 <p className="text-xs text-blue-400 font-bold uppercase tracking-wider mb-1 flex justify-center items-center gap-1"><Banknote className="h-4 w-4"/> Custo Total na Conta de Luz</p>
                 <div className="font-display text-2xl font-black text-blue-400">
                   R$ {custoTotal.toFixed(2)}
                 </div>
              </div>
           </div>
        </div>
      </motion.div>
    </div>
  );
};
export default SimuladorRecarga;




